import { createContext } from 'react';

const TiendaContext = createContext();

export default TiendaContext;